import { render } from "./ErrorAlert.vue?vue&type=template&id=64e6a9e2&scoped=true"
import script from "./ErrorAlert.vue?vue&type=script&lang=js"
export * from "./ErrorAlert.vue?vue&type=script&lang=js"

import "./ErrorAlert.vue?vue&type=style&index=0&id=64e6a9e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e6a9e2"]])

export default __exports__